import { render, staticRenderFns } from "./FeedbackDetailModal.vue?vue&type=template&id=9497453a&scoped=true"
import script from "./FeedbackDetailModal.vue?vue&type=script&lang=js"
export * from "./FeedbackDetailModal.vue?vue&type=script&lang=js"
import style0 from "./FeedbackDetailModal.vue?vue&type=style&index=0&id=9497453a&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9497453a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9497453a')) {
      api.createRecord('9497453a', component.options)
    } else {
      api.reload('9497453a', component.options)
    }
    module.hot.accept("./FeedbackDetailModal.vue?vue&type=template&id=9497453a&scoped=true", function () {
      api.rerender('9497453a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/CommonPage/NotCollectedBasemap/components/FeedbackDetailModal.vue"
export default component.exports